import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import { toast } from 'react-toastify';
import { normsLibrary } from '../../helpers/adipiBackendUrl';
import { deleteApiCall, getTable, patchApiCall, postApiCall, postApiFileCall } from "../../services/mainServices";
import {
  ADD_NEW_NORMSLIBRARY,
  DELETE_NORMSLIBRARY,
  GET_NORMSLIBRARYS,
  UPDATE_NORMSLIBRARY
} from "./actionTypes";
import {
  addNormsLibraryFail,
  addNormsLibrarySuccess,
  deleteNormsLibraryFail,
  deleteNormsLibrarySuccess,
  getNormsLibrarysFail,
  getNormsLibrarysSuccess,
  setState,
  updateNormsLibraryFail,
  updateNormsLibrarySuccess,
} from "./actions";

//Include Both Helper File with needed methods

function* fetchNormsLibrarys( { payload: { params } } ) {
  try {
    yield put(setState(true))
    const response = yield call(getTable, normsLibrary, params.toString());
    yield put(setState(false))
    yield put(getNormsLibrarysSuccess(response.items,response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false))
    yield put(getNormsLibrarysFail(error));
  }
}

function* updateNormsLibrary ({payload: normsLibraryObj }) {
  try {
    const { id, recordStatus, ...rest } = normsLibraryObj;
    yield call(patchApiCall, `${normsLibrary}/${id}`, rest);
    const response = yield call(getTable,`${normsLibrary}/${normsLibraryObj.id}`);
    yield put(updateNormsLibrarySuccess(response));
    toast.success('Registro actualizado correctamente')
  } catch (error) {
    yield put(updateNormsLibraryFail(error));
    toast.error('Error al actualizar el registro')
  }
}

function* updateNormsLibraryStatus ({payload: normsLibraryObj }) {
  try {
    const response = yield call(getTable,`${normsLibrary}/${normsLibraryObj.id}`);
    yield put(updateNormsLibrarySuccess(response));
  } catch (error) {
    yield put(updateNormsLibraryFail(error));
  }
}

function* deleteNormsLibrary ({payload: normsLibraryObj}) {
  try {
    yield call(deleteApiCall,`${normsLibrary}/${normsLibraryObj.id}`);
    yield put(deleteNormsLibrarySuccess(normsLibraryObj.id));
    toast.success('Registro borrado correctamente')

  } catch (error) {
    yield put(deleteNormsLibraryFail(error));
    toast.error('Error al borrar el registro')

  }
}

function* postingNormsLibrary ({ payload: normsLibraryObj }) {
  try {
    const { isPostingFile, ...rest} = normsLibraryObj
    let response
    if(isPostingFile){
      response = yield call(postApiFileCall, normsLibrary ,rest);
    }else{
      response = yield call(postApiCall, normsLibrary ,rest);
    }
    const response1 = yield call(getTable,`${normsLibrary}/${response.id}`);
    yield put(addNormsLibrarySuccess(response1));
    toast.success('Registro agregado correctamente')

  } catch (error) {
    yield put(addNormsLibraryFail(error));
    toast.error('Error al agregar el registro')

  }
}

function* normsLibrarysSaga() {
  yield takeEvery(GET_NORMSLIBRARYS, fetchNormsLibrarys);
  yield takeEvery(ADD_NEW_NORMSLIBRARY, postingNormsLibrary);
  yield takeEvery(UPDATE_NORMSLIBRARY, updateNormsLibrary);
  yield takeEvery(UPDATE_NORMSLIBRARY, updateNormsLibraryStatus);
  yield takeEvery(DELETE_NORMSLIBRARY, deleteNormsLibrary);
}

export default normsLibrarysSaga;
